import { INotificationLogResult } from 'app/models/ActivityFeed/IActivityLogs';
import { TaskNotificationType } from 'app/models/Tasks/Tasks';

export const DEDUPED_TASK_ALERT_SUB_TYPES = new Set([
  TaskNotificationType.TASKCREATED.toString(),
  TaskNotificationType.SUBTASKCREATED.toString(),
]);

const getAssociatedRecordValue = (records: unknown, targetName: string): string | undefined => {
  if (!Array.isArray(records)) {
    return undefined;
  }
  const needle = targetName.toLowerCase();
  const row = records.find((record: { name?: string }) => (record?.name ?? '').toLowerCase() === needle);
  const value = row?.value;
  if (value === undefined || value === null) {
    return undefined;
  }
  const normalized = `${value}`.trim();
  return normalized.length > 0 ? normalized : undefined;
};

/** Stable key for task-created/subtask-created notifications (matches toast dedupe intent). */
export const getTaskAlertDedupeKey = (log: INotificationLogResult, employeeId?: string): string | undefined => {
  if (!DEDUPED_TASK_ALERT_SUB_TYPES.has(log?.useSubType?.toString())) {
    return undefined;
  }

  const taskId = getAssociatedRecordValue(log?.associatedRecords, 'TaskId');
  if (!taskId) {
    return undefined;
  }

  const recipientId =
    employeeId?.toString()?.trim() || log?.message?.tos?.find(Boolean)?.contactId?.toString()?.trim();
  if (!recipientId) {
    return undefined;
  }

  return `${log.useSubType}:${taskId}:${recipientId}`;
};

export const dedupeTaskNotificationLogResults = (
  results: INotificationLogResult[] = [],
  employeeId?: string,
): INotificationLogResult[] => {
  const seenIds = new Set<string>();
  const seenTaskAlertKeys = new Set<string>();

  return results.filter(item => {
    if (item?.id && seenIds.has(item.id)) {
      return false;
    }

    const taskAlertKey = getTaskAlertDedupeKey(item, employeeId);
    if (taskAlertKey) {
      if (seenTaskAlertKeys.has(taskAlertKey)) {
        return false;
      }
      seenTaskAlertKeys.add(taskAlertKey);
    }

    if (item?.id) {
      seenIds.add(item.id);
    }

    return true;
  });
};
